import { Col } from "react-bootstrap"
import { formatPrice } from "../../../../helpers/formatPrice"
import { useAppSelector } from "../../../../services/hooks"
import { Link } from "react-router"

type ShowImagePanelProps = {
    content: any,
    maxImages: number
}

export default function ShowImagePanel({ content, maxImages }: ShowImagePanelProps) {
    const currency = useAppSelector((state) => state.user.currency)
    const showImagePanels = content.products.map((panel: any, index: number) => {
        if (index < maxImages) return (
            <Col key={index} xs={12} md={12 / content.products.length} className="text-center">
                <Link to={`/product/${panel.slug}`}>
                    <img src={panel.img} alt="" className="img-fluid rounded-circle border border-2 border-warning d-block" />
                </Link>
                {/* TODO: link breadcrumbs */}
                <a href={panel.link} className="d-block link-dark link-underline-opacity-0 fw-medium my-2  small fw-bolder text-truncate">
                    {panel.name}<br />
                    <small className="fw-normal ">{formatPrice(panel.price, currency)} / {panel.unit}</small>
                </a>
            </Col>
        )
    })
    return showImagePanels
}